/**
 * HTML snippets for SweetAlert progress flows (`uploading` / `waiting`).
 */

export const uploadingFile = () => `
  <div>
    <h4 id="uploading-title" class="swal_title mb-2">
      Uploading<span class="dot-animation">.</span>
    </h4>
    <p class="swal_text">Please wait while we upload your file.</p>
    <div style="width:100%;height:10px;margin-top:10px;background:rgba(0,0,0,0.06);border-radius:9999px;overflow:hidden;">
      <div class="progress-bar" role="progressbar" style="width:10%;height:100%;background:#0f4c81;transition:width .3s ease;"></div>
    </div>
  </div>
`;

export const wait = () => `
  <div>
    <h3 id="uploading-title" class="swal_title my-3">Please wait...</h3>
    <p class="swal_text">Please wait while we process your request.</p>
    <div style="width:100%;height:10px;margin-top:10px;background:rgba(0,0,0,0.06);border-radius:9999px;overflow:hidden;">
      <div class="progress-bar" role="progressbar" style="width:10%;height:100%;background:#0f4c81;transition:width .3s ease;"></div>
    </div>
  </div>
`;
